import axios from "axios";
import { payments, paymentAccounts, paymentMethodByCountry } from "./data";


export const createPaymentAccountMobile = async (requestData) => {
    try {
        const response = await axios.post(process.env.REACT_APP_TRANSACTION_BASE_URL+`/reversement-accounts/mobile-money`, requestData.newAccount);
        return response;
    } catch (error) {
        throw error;
    }
}

export const createPaymentAccountCardBank = async (requestData) => {
    try {
        const response = (await axios.post(process.env.REACT_APP_TRANSACTION_BASE_URL+`/reversement-accounts/card-bank`, requestData));
        return response;
    } catch (error) {
        throw error;
    }
}

export const getPaymentsByMerchantId = async (merchandId) => {
    try {
        const response = await axios.get(process.env.REACT_APP_TRANSACTION_BASE_URL+`/reversement-accounts/by-owner/${merchandId}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const deletePaymentAccount = async (paymentAccountId, merchandId) => {
    try {
        const response = await axios.delete(process.env.REACT_APP_API_BASE_URL+`/payments/payment-accounts/${merchandId}/${paymentAccountId}`);
        return response;
    } catch(error) {
        throw error;
    }
}

export const getPaymentAccountsByMerchantId = (merchantId) => {
    return paymentAccounts;
}

export const getPaymentMethodsByCountry = async ()=> {
    try {
        const response = await axios.get(process.env.REACT_APP_TRANSACTION_BASE_URL+`/payment-methods/by-country`);
        return response;
    } catch(error) {
        throw error;
    }
}